// extracted by mini-css-extract-plugin
export default {"container":"Vo-z","bubbleNav":"Wo-z","graphic":"Xo-z","contact":"Yo-z"};